import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { handleError } from "../../../helpers/ErrorHelper";

// Paginated server list feeding the "Filter Server" dropdown. Kept separate
// from `server_modules_get` because that slice is driven by the Servers list
// page params and is replaced on every fetch — this one accumulates pages so
// the menu can grow as the user scrolls.
export const SERVER_DROPDOWN_LIMIT = 25;

// Local to this action: the shared `debounce` singleton is used by the list
// screens, and reusing it here would cancel their in-flight requests.
let searchTimeout = null;

function _success(success, append) {
  return { type: "GET_SERVER_MODULES_DROPDOWN_SUCCESS", success, append };
}

function _error(error) {
  return { type: "GET_SERVER_MODULES_DROPDOWN_ERROR", error };
}

function _processing(processing) {
  return { type: "GET_SERVER_MODULES_DROPDOWN_PROCESSING", processing };
}

function _reset() {
  return { type: "GET_SERVER_MODULES_DROPDOWN_RESET" };
}

export function resetServerModulesDropdown() {
  return function (dispatch) {
    dispatch(_reset());
  };
}

function getServerModulesDropdown({
  page = 1,
  q = ``,
  append = false,
  shouldDebounce = false,
} = {}) {
  return (dispatch) => {
    dispatch(_processing(true));
    dispatch(_error(null));

    const request = () =>
      axios({
        url: apiBaseUrl(`admin/servers`),
        method: "get",
        dataType: "json",
        params: { page, limit: SERVER_DROPDOWN_LIMIT, q },
        headers: {
          Authorization: "Bearer " + localStorage.getItem(`Bearer`),
        },
      })
        .then(function (res) {
          dispatch(_success(res, append));
        })
        .catch(function (error) {
          handleError(error);
          dispatch(_error(error));
        })
        .finally(function () {
          dispatch(_processing(false));
        });

    if (searchTimeout) {
      clearTimeout(searchTimeout);
      searchTimeout = null;
    }

    if (shouldDebounce) {
      searchTimeout = setTimeout(request, 500);
    } else {
      request();
    }
  };
}

export default getServerModulesDropdown;
